import { LegalDocumentPage } from "@/components/pages/legal-document-page";

export default function TermsConditionsPage() {
  return (
    <LegalDocumentPage
      title="Terms & Conditions"
      htmlUrl="/terms-conditions.html"
      defaultReturnPath="/"
    />
  );
}

